import classnames from 'classnames';
import dynamic from 'next/dynamic';
import { memo } from 'react';

import mebotThinking from '@/assets/mebot_thinking.json';
import { useTranslation } from '@/i18n/client';

import styles from './index.less';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface IProps {
  className?: string;
  content?: string;
}

function MindHint(props: IProps): JSX.Element | null {
  const { className, content } = props;

  const { t } = useTranslation();

  return (
    <div className={classnames(styles.mindHint, 'flex items-center transition-all', className)}>
      <Lottie
        animationData={mebotThinking}
        autoPlay
        loop
        style={{ width: '32px', height: '32px', display: 'inline-block', marginRight: '8px' }}
      />
      <div className={styles.linearText}>{content || t('chatApp.taptap')}</div>
    </div>
  );
}

export default memo(MindHint);
